
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/v20/wallet/staking/undelegate",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/v20/wallet/staking/undelegate/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/v20/wallet/staking/undelegate"])
      });
    }
  